import {usePortalTooltip} from '@github-ui/portal-tooltip/use-portal-tooltip'
import {testIdProps} from '@github-ui/test-id-props'
import {XCircleFillIcon} from '@primer/octicons-react'
import {IconButton} from '@primer/react'
import {memo, useRef} from 'react'

import {Resources} from '../../strings'

type ClearFilterButtonProps = {
  /**
   * An optional handler for click events on the button. If undefined,
   * the button will not be rendered.
   */
  onClick?: React.MouseEventHandler<HTMLButtonElement>

  /**
   * An optional handler for keydown events on the button
   */
  onKeyDown?: React.KeyboardEventHandler<HTMLButtonElement>
}

export const ClearFilterButton = memo(function ClearFilterButton({onClick, onKeyDown}: ClearFilterButtonProps) {
  return onClick ? <ClearFilterButtonWithTooltip onClick={onClick} onKeyDown={onKeyDown} /> : null
})

const ClearFilterButtonWithTooltip = ({onClick, onKeyDown}: ClearFilterButtonProps) => {
  const ref = useRef<HTMLButtonElement>(null)
  const [contentProps, tooltip] = usePortalTooltip({
    contentRef: ref,
    'aria-label': Resources.clearFilter,
    direction: 'sw',
    anchorSide: 'outside-bottom',
  })
  return (
    <>
      <IconButton
        ref={ref}
        variant="invisible"
        onClick={onClick}
        onKeyDown={onKeyDown}
        icon={XCircleFillIcon}
        size="small"
        aria-label={Resources.clearFilter}
        {...contentProps}
        {...testIdProps('clear-filter-query')}
      />
      {tooltip}
    </>
  )
}

try{ ClearFilterButton.displayName ||= 'ClearFilterButton' } catch {}
try{ ClearFilterButtonWithTooltip.displayName ||= 'ClearFilterButtonWithTooltip' } catch {}